import React from 'react'

import {
  carModelDisplayLabel,
  carSubModelDisplayLabel,
  getMaskedString,
} from '@/utils'
import { CarNode } from '@/apollo/graphql'
import { useApp } from '@/hooks'

import carImg from '@/assets/images/404.png'

const CarRow: React.FC<{
  node?: CarNode
  onClick: (node?: CarNode) => void
}> = ({ node, onClick }) => {
  const { isRTL } = useApp()
  return (
    <li onClick={() => onClick(node)}>
      <div className="data">
        <h4>{carModelDisplayLabel(node as any, isRTL)}</h4>
        <p>{carSubModelDisplayLabel(node as any, isRTL)}</p>
        <p>{getMaskedString((node as any).number, true)}</p>
      </div>
    </li>
  )
}

export default CarRow
